module.exports = __webpack_public_path__ + "img/LG-cc-ti-03.8a92f2f5.png";